import React from "react";
export default (({
  styles = {},
  ...props
}) => <svg width="19" height="19" viewBox="0 0 19 19" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}><path d="M9.635 17.67a8.335 8.335 0 100-16.67" stroke="#ECBF2D" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" /><path d="M9.335 17.67a8.335 8.335 0 110-16.67" stroke="#ECBF2D" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" strokeDasharray="3 4" /></svg>);